import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["codeInput"];

  connect() {
    this.codeInputTargets.forEach((input, i) => {
      input.addEventListener("paste", (e) => this.onPaste(e, i));
      input.addEventListener("input", (e) => this.onInput(e, i));
      input.addEventListener("keydown", (e) => this.onKeyDown(e, i));
    });
  }

  disconnect() {
    this.codeInputTargets.forEach((input, i) => {
      input.removeEventListener("paste", this.onPaste);
      input.removeEventListener("input", this.onInput);
      input.removeEventListener("keydown", this.onKeyDown);
    });
  }

  stripSpecialChars = (string) => {
    if (this.inputModeValue === "numeric") {
      return string?.replace(/[^0-9]/g, "");
    }

    return string?.replace(/\W/g, "");
  };

  onPaste = (e, currentIndex) => {
    let text = e.clipboardData.getData("text");
    if (!text) return;

    // only keep alphanumeric chars
    text = this.stripSpecialChars(text);

    const inputFieldsToPasteInto = this.codeInputTargets.slice(currentIndex);

    inputFieldsToPasteInto.forEach((field, i) => {
      setTimeout(() => {
        if (text[i]) {
          this.setInputValue(field, text[i]);
          inputFieldsToPasteInto[i + 1]?.focus();
        }
      }, i * 20);
    });
  };

  onInput = (e, currentIndex) => {
    const value = this.stripSpecialChars(e.target.value);
    this.setInputValue(e.target, value);
    if (!value) {
      return;
    }

    const nextField = this.codeInputTargets[currentIndex + 1];
    if (value && value.length === 1 && nextField) {
      nextField.focus();
    }
  };

  onKeyDown = (e, currentIndex) => {
    const previousField = this.codeInputTargets[currentIndex - 1];
    const nextField = this.codeInputTargets[currentIndex + 1];

    const goTo = (field) => {
      if (!field) return;

      field.select();
      field.focus();
    };

    e.currentTarget.select();

    if (e.key === "ArrowLeft") goTo(previousField);
    if (e.key === "ArrowRight") goTo(nextField);
    if (e.key === "Backspace") {
      // If the input field already has a value, delete it...
      if (e.currentTarget.value) {
        this.setInputValue(e.currentTarget, "");
        return;
      }

      // ...otherwise go back to the previous field and delete its value
      goTo(previousField);
      previousField && this.setInputValue(previousField, "");
    }
  };

  setInputValue = (input, value) => {
    input.value = value;
    input.setAttribute("value", value);
  };
}
